import { clsx, type ClassValue } from "clsx";

/** Compose class names. Every component takes an optional `class` and merges it last. */
export const cn = (...inputs: ClassValue[]): string => clsx(inputs);
